<div class="grid grid-cols-[repeat(auto-fill,minmax(min(260px,100%),320px))] gap-3">
    @for (tile of tiles(); track tile.label) {
        <app-nav-tile
            [icon]="tile.icon"
            [label]="tile.label"
            [description]="tile.description"
            [link]="tile.link"
            [externalLink]="tile.externalLink"
            [testId]="tile.testId"
        ></app-nav-tile>
    }
</div>
